transformations = {
  "meta.chaptercategory": {
    "IN": "In-service inspection",
    "PRINCIPLES": "Principles for selection",
    "INFORMATION": "User-designer information exchange",
    "INSTALLATION": "Installation and commissioning",
    "SAFE": "Safe use",
    "LEGAL": "Legal requirements",
    "MARKING": "Marking & storage",
    "INSPECTION": "Inspection and maintenance",
    "TRAINING": "Training",
    "SCOPE": "Scope",
    "TYPES": "Types",
    "DEFINITIONS": "Definitions",
    "FOREWORD": "Foreword"
  },
};
